let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("WTdWH")).then(() => parcelRequire('Cm4aW'));